/* ============================================================
   eQiik — scripts propios (vanilla, sin librerías)
   Una función init por componente; cada una comprueba si su
   elemento existe antes de actuar.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveals al hacer scroll ---- */
  function initReveals() {
    var els = document.querySelectorAll('.eq-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('eq-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('eq-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---- Cifras animadas (count-up) ---- */
  function initCountUp() {
    var nums = document.querySelectorAll('[data-countup]');
    if (!nums.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-countup'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-countup'));
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent = (target % 1 === 0) ? Math.round(val) : val.toFixed(1);
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = el.getAttribute('data-countup');
        }
        requestAnimationFrame(step);
        obs.unobserve(el);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { obs.observe(n); });
  }

  /* ---- FAQ acordeón ---- */
  function initFaq() {
    var items = document.querySelectorAll('.eq-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector('.eq-faq__q');
      var ans = item.querySelector('.eq-faq__a');
      if (!btn || !ans) return;
      btn.addEventListener('click', function () {
        var open = item.getAttribute('aria-expanded') === 'true';
        item.setAttribute('aria-expanded', open ? 'false' : 'true');
        ans.style.maxHeight = open ? null : ans.scrollHeight + 'px';
      });
    });
  }

  /* ---- Galería de producto ---- */
  function initGallery() {
    var gallery = document.querySelector('[data-eq-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-eq-main-img]');
    var thumbs = gallery.querySelectorAll('.eq-prod__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (src) main.src = src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---- Selector de variantes ---- */
  function initVariants() {
    var form = document.querySelector('[data-eq-product-form]');
    if (!form) return;
    var dataEl = document.querySelector('[data-eq-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-eq-price]');
    var addBtn = form.querySelector('[data-eq-add]');
    var buttons = document.querySelectorAll('.eq-prod__variant');
    if (!buttons.length) return;

    function money(cents) {
      var v = (cents / 100);
      return v.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    function select(variantId) {
      var v = variants.filter(function (x) { return String(x.id) === String(variantId); })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = '<span>' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<del>' + money(v.compare_at_price) + '</del>';
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('disabled'); addBtn.textContent = addBtn.getAttribute('data-label') || 'Añadir al carrito'; }
        else { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = 'Agotado'; }
      }
    }
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        select(btn.getAttribute('data-variant-id'));
      });
    });
  }

  /* ---- Selector de cantidad ---- */
  function initQty() {
    var box = document.querySelector('[data-eq-qty]');
    if (!box) return;
    var input = box.querySelector('[data-eq-qty-input]');
    var minus = box.querySelector('[data-eq-qty-minus]');
    var plus = box.querySelector('[data-eq-qty-plus]');
    if (!input) return;
    function clamp() {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      input.value = v;
    }
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    input.addEventListener('change', clamp);
  }

  /* ---- Opción de Seguro eQiik en la página de producto ---- */
  function initSeguro() {
    var box = document.querySelector('[data-eq-seguro]');
    var form = document.querySelector('[data-eq-product-form]');
    if (!box || !form) return;
    var check = box.querySelector('[data-eq-seguro-check]');
    var seguroId = box.getAttribute('data-seguro-id');
    // ID del plan de suscripción del seguro: si existe, el seguro se cobra mensualmente
    var seguroPlan = parseInt(box.getAttribute('data-seguro-plan'), 10) || 692482670926;
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[data-eq-qty-input]');
    var payBtn = document.querySelector('.shopify-payment-button');
    if (!check || !seguroId || !idInput) return;

    // Precio en vivo: al marcar el seguro mostramos el descuento de 100€
    var priceEl = document.querySelector('[data-eq-price]');
    var DISC = parseInt(box.getAttribute('data-seguro-discount'), 10) || 10000;
    var variants = [];
    var dEl = document.querySelector('[data-eq-variants]');
    if (dEl) { try { variants = JSON.parse(dEl.textContent); } catch (e) {} }
    function money(c) { return (c / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
    function curVar() {
      for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(idInput.value)) return variants[i]; }
      return null;
    }
    function renderPrice() {
      if (!priceEl) return;
      var v = curVar();
      var base = v ? v.price : null;
      if (check.checked && base != null) {
        var net = Math.max(0, base - DISC);
        priceEl.innerHTML = '<del>' + money(base) + '</del><span class="eq-prod__price-now">' + money(net) + '</span><span class="eq-prod__price-seg">−' + money(DISC) + ' con Seguro eQiik</span>';
      } else if (base != null) {
        var html = '<span>' + money(base) + '</span>';
        if (v && v.compare_at_price && v.compare_at_price > base) html += '<del>' + money(v.compare_at_price) + '</del>';
        priceEl.innerHTML = html;
      }
    }
    // Al marcar: recalcula precio y oculta el pago rápido (Shop Pay no incluye el seguro)
    check.addEventListener('change', function () {
      if (payBtn) payBtn.style.display = check.checked ? 'none' : '';
      renderPrice();
    });
    // Si cambia el modelo con el seguro marcado, re-aplica el descuento tras actualizarse el precio
    document.querySelectorAll('.eq-prod__variant').forEach(function (b) {
      b.addEventListener('click', function () { if (check.checked) setTimeout(renderPrice, 0); });
    });

    form.addEventListener('submit', function (e) {
      if (!check.checked) return; // compra normal (solo inodoro)
      e.preventDefault();
      var mainId = idInput.value;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var addBtn = form.querySelector('[data-eq-add]');
      if (addBtn) { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = 'Añadiendo…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [
          { id: parseInt(mainId, 10), quantity: qty },
          { id: parseInt(seguroId, 10), quantity: 1, selling_plan: seguroPlan }
        ] })
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          if (addBtn) { addBtn.removeAttribute('disabled'); addBtn.textContent = addBtn.getAttribute('data-label') || 'Añadir al carrito'; }
          window.location.href = '/cart';
        });
    });
  }

  function boot() {
    if (window.__eqBooted) return; // el script se incluye 1 vez por sección; init solo una vez
    window.__eqBooted = true;
    initReveals();
    initCountUp();
    initFaq();
    initGallery();
    initVariants();
    initQty();
    initSeguro();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
